import { STATUS } from "../../../../../../ui/StatusLabel/constants/status";
import { SEARCH_RESULT_STATUS_MAP } from "../../../../constants/searchResultStatusMap";

import type { EventSearchResultItem } from "../../../../types/eventSearchResultItem";
import type { LegacyPortalSearchResultEvent } from "@spwn-portal/grpc";

type Input = LegacyPortalSearchResultEvent;
type Output = EventSearchResultItem;
type ConvertResponse = (input: Input) => Output;

export const convertResponse: ConvertResponse = (item) => {
  return {
    id: item.id,
    title: item.title,
    eventBanner: item.eventBanner,
    defaultImage: item.defaultImage,
    eventStartTime: Number(item.eventStartTime),
    eventEndTime: Number(item.eventEndTime),
    artists: item.artists,
    parts: item.parts.map((part) => ({
      name: part.name,
      openTime: Number(part.openTime),
      startTime: Number(part.startTime),
    })),
    isClosed: item.isClosed,
    eventStatus: SEARCH_RESULT_STATUS_MAP[item.label] ?? STATUS.NO_LABEL,
  };
};
